import { render, staticRenderFns } from "./retrieve.vue?vue&type=template&id=4dc7b124"
import script from "./retrieve.vue?vue&type=script&lang=ts"
export * from "./retrieve.vue?vue&type=script&lang=ts"
import style0 from "./retrieve.vue?vue&type=style&index=0&id=4dc7b124&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports